var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.249,
    height: 14,
    viewBox: "0 0 12.249 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play",
    "data-name": "Icon awesome-play",
    d: "M11.6,5.872,1.98.182A1.305,1.305,0,0,0,0,1.311V12.688a1.311,1.311,0,0,0,1.98,1.129L11.6,8.13A1.311,1.311,0,0,0,11.6,5.872Z",
    transform: "translate(0 -0.002)",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.9a9d750e280f0b682496af6b57a9e24c.svg";
export { ForwardRef as ReactComponent };